function oniAutocomplete(param)
{
    /***************
     *** Options ***
     ***************/
    var $input = param.input,
        delay = 250,

        caseSensitive = false,
        globalAccents = true,

        url = param.url,
        method = 'get',
        /* param.data = [{key: '', value: ''}, {key: '', value: ''}, {key: '', value: ''}] */
        dataType = 'json',

        position = 'bottom',

        keyShow = param.keyShow,
        keySearch = param.keySearch,

        sameWidth = true,

        timeout = 0,
        minLength = 1,

        classWrapper = 'autocomplete-wrapper',
        classInputWrapper = 'autocomplete-input-wrapper',
        classListWrapper = 'autocomplete-list-wrapper',
        classList = 'autocomplete-list';

    if (typeof(param.delay) != 'undefined') {
        delay = param.delay;
    } if (typeof(param.method) != 'undefined') {
    method = param.method;
} if (typeof(param.classWrapper) != 'undefined') {
    classWrapper = param.classWrapper;
} if (typeof(param.classInputWrapper) != 'undefined') {
    classInputWrapper = param.classInputWrapper;
} if (typeof(param.classList) != 'undefined') {
    classList = param.classList;
} if (typeof(param.dataType) != 'undefined') {
    dataType = param.dataType;
} if (typeof(param.minLength) != 'undefined') {
    minLength = param.minLength;
} if (typeof(param.sameWidth) != 'undefined') {
    sameWidth = param.sameWidth;
} if (typeof(param.caseSensitive) != 'undefined') {
    caseSensitive = param.caseSensitive;
} if (typeof(param.globalAccents) != 'undefined') {
    globalAccents = param.globalAccents;
} if (typeof(param.position) != 'undefined') {
    position = param.position;
}

    /***************
     *** Accents ***
     ***************/
    var accentsRegex = {
        'lowercase': {
            'a': /[aâäàãå]/g,
            'c': /[cç]/g,
            'e': /[eëèéê]/g,
            'i': /[iîïìı]/g,
            'n': /[nñ]/g,
            'o': /[oóòŏôốồỗổǒöȫőõṍṏȭȯȱøǿǫǭōṓṑỏȍȏơớờỡởợọộɵ]/g,
            'u': /[uùûü]/g,
            'y': /[yÿ]/g,
            'ae': /æ/g,
            'oe': /œ/g
        },

        'uppercase': {
            'A': /[AÂÄÀÃÅ]/g,
            'C': /[CÇ]/g,
            'E': /[EËÈÉÊ]/g,
            'I': /[IÎÏÌı]/g,
            'N': /[NÑ]/g,
            'O': /[OÓÒŎÔỐỒỖỔǑÖȪŐÕṌṎȬȮȰØǾǪǬŌṒṐỎȌȎƠỚỜỠỞỢỌỘƟ]/g,
            'U': /[UÙÛÜ]/g,
            'Y': /[YŸ]/g,
            'AE': /Æ/g,
            'OE': /Œ/g
        }
    };

    var accents = function (string) {
        $.each(accentsRegex, function (key, type) {
            $.each(accentsRegex[key], function (letter, regex) {
                string = string.replace(regex, letter);
            });
        });

        return string;
    };

    var antiRegex = function (string) {
        string = string.replace(/\\/g, '\\\\')
            .replace(/\?/g, '\\?')
            .replace(/\(/g, '\\(')
            .replace(/\)/g, '\\)')
            .replace(/\[/g, '\\[')
            .replace(/\]/g, '\\]')
            .replace(/\{/g, '\\{')
            .replace(/\}/g, '\\}')
            .replace(/\*/g, '\\*')
            .replace(/\^/g, '\\^')
            .replace(/\$/g, '\\$')
            .replace(/\./g, '\\.')
            .replace(/\+/g, '\\+')
            .replace(/\|/g, '\\|');

        return string;
    };

    /**************
     *** Layout ***
     **************/
    if ($input.length) {
        $input.each(function (index) {
            var $t = $(this);

            $t.attr({'aria-expanded' : "false"});

            if (!$t.parents('.' + classInputWrapper).length) {
                $t.wrap('<div class="' + classInputWrapper + '"></div>');
                $t.parents('.' + classInputWrapper).wrap('<div class="' + classWrapper + ' flex-1"></div>');
                $t.attr('autocomplete', 'off');

                if (position.match(/^top$/i)) {
                    $t.parents('.' + classWrapper).prepend('<ul class="' + classList + ' position-top"></ul>');
                } else {
                    $t.parents('.' + classWrapper).append('<ul class="' + classList + '"></ul>');
                }

                $t.parents('.' + classWrapper).find('.' + classList).attr('id',  'list-box' + index  ).attr('role', 'listbox').attr('arial-label', 'Ville')
                $t.parents('.' + classWrapper).find('.' + classList).wrap('<div class="' + classListWrapper + ' hidden"></div>');
            }
        });
    }

    var itemRow = function (key, show, rawTerm) {
        if (caseSensitive) {
            var regexOptions = 'g';
        } else {
            var regexOptions = 'gi';
        }

        var term = rawTerm;

        if (globalAccents) {
            $.each(accentsRegex['lowercase'], function (key, accent) {
                term = term.replace(new RegExp(accent.source, regexOptions), accent.source);
            });
        }

        var finalRegexTerm = new RegExp('(' + term + ')', regexOptions),
            render = show.replace(finalRegexTerm, '<b>$1</b>');

        return '<li><a href="javascript:;" data-key="' + key + '" role="option">' + render + '</a></li>' + '\n';
    };

    /********************
     *** Data parsing ***
     ********************/
    var dataParsing = function ($input, data) {
        var markup = '',
            rawTerm = $input.val(),
            $list = $input.parents('.' + classWrapper).find('.' + classList),
            $listWrapper = $list.parents('.' + classListWrapper),
            loop = 0;

        rawTerm = antiRegex(rawTerm);

        if (globalAccents) {
            var term = accents(rawTerm);
        } else {
            var term = rawTerm;
        }

        $.each(data, function (key, row) {
            var show = '',
                search = '';

            if (
                param.item &&
                param.item.addProperty &&
                param.item.addProperty.name &&
                param.item.addProperty.value
            ) {
                row[param.item.addProperty.name] = param.item.addProperty.value(row);
                data[key][param.item.addProperty.name] = param.item.addProperty.value(row);
            }

            /************************
             *** Custom item show ***
             ************************/
            if (
                param.item &&
                param.item.show
            ) {
                show = param.item.show(row);
                search = row[keySearch];
            } else if (keyShow && keySearch) {
                show = row[keyShow];
                search = row[keySearch];
            } else {
                show = row;
                search = row;
            }

            show = show.toString();
            search = search.toString();

            if (globalAccents) {
                search = accents(search);
            }

            if (caseSensitive) {
                var regexOptions = 'g';
            } else {
                var regexOptions = 'gi';
            }

            if (param.exclude) {
                search = antiRegex(search);

                var exclude = false,
                    regexclude = new RegExp(search, regexOptions);
                $.each(param.exclude, function (i, val) {
                    if (globalAccents) {
                        val = accents(val);
                    }

                    if (val.match(regexclude)) {
                        exclude = true;
                        return false;
                    }
                });

                if (exclude) {
                    return true;
                }
            }

            markup += itemRow(key, show, rawTerm);
            loop++;

            if (param.limit >= 1 && loop > (param.limit - 1)) {
                return false;
            }
        });

        if (markup) {
            $list.html(markup);
            $input.attr('aria-expanded', 'true');
            $listWrapper.removeClass('hidden').children().attr('aria-expanded', 'true');


            if (sameWidth) {
                var inputWidth = $input.outerWidth();
                $listWrapper.css({'width': inputWidth + 'px'});
            }

            if (param.onItemHover) {
                var on = function (e) {
                    var $t = $(this),
                        id = $t.attr('data-key');
                    param.onItemHover({
                        data: data[id],
                        value: $t.text()
                    }, $input, $list);
                };
                $list.find('a').focus(on);
            }

            $list.find('a').on('click', function (e) {
                var $t = $(this),
                    id = $t.attr('data-key');

                if (param.onItemSelect) {
                    param.onItemSelect({
                        data: data[id],
                        value: $t.text()
                    }, $input, $list);
                } else {
                    $input.val( $t.text() ).trigger('input');
                    $listWrapper.addClass('hidden').removeAttr('style');
                }
            });
        } else {
            $listWrapper.addClass('hidden').removeAttr('style').children().attr('aria-expanded', 'false');
            $list.html('');

            if (param.onNoResults) {
                param.onNoResults($list, $input);
            }
        }
    };

    /************
     *** Init ***
     ************/
    var init = function (e) {
        var $t = $(this),
            rawTerm = $t.val(),
            $list = $t.parents('.' + classWrapper).find('.' + classList),
            $listWrapper = $list.parents('.' + classListWrapper),
            queryUrl = url,
            data = [],
            markup = '';

        if (e.type == 'focus' && !$listWrapper.hasClass('hidden')) {
            return false;
        }

        if (param.trim) {
            rawTerm = rawTerm.trim();
        }

        if (rawTerm.length >= minLength) {
            if (url) {
                /**************
                 *** Remote ***
                 **************/

                var postData = {};

                if (method.match(/^get$/i)) {
                    queryUrl = url.replace(/\<term\>/, encodeURIComponent(rawTerm));
                } else {
                    queryUrl = url,
                        postData = param.postData;
                }

                if (timeout) {
                    clearTimeout(timeout);
                }

                timeout = setTimeout(function () {
                    if (param.onLoading) {
                        param.onLoading($(this), $t);
                    }

                    $.ajax({
                        url: queryUrl,
                        method: method,
                        data: postData,
                        dataType: dataType
                    }).done(function (response) {
                        if (response) {
                            $.each(response, function (key, value) {
                                data[key] = value;
                            });

                            dataParsing($t, data);
                        }
                    });
                }, delay);
            } else {
                /*************
                 *** Local ***
                 *************/

                data = param.data;

                dataParsing($t, data);
            }
        } else {
            if (param.onNotEnough) {
                param.onNotEnough($t, $list);
            } else {
                $listWrapper.addClass('hidden').removeAttr('style');
                $list.html('');
            }
        }
    };

    if ($input.length) {
        $input.each(function () {
            var $t = $(this);

            $t.off('input focus blur')
                .on('input focus', init);
        });
    }

    /**************
     *** Access ***
     **************/
    $(document).on('keydown', function (e) {
        /*
          38: up
          40: down
          37: left
          39: right
          13: enter
          27: esc
          32: space
          9: tab
        */
        if ($input.length) {
            $input.each(function () {
                var $t = $(this),
                    key = e.keyCode,
                    $list = $t.parents('.' + classWrapper).find('.' + classList),
                    $listWrapper = $list.parents('.' + classListWrapper),
                    $a = $list.find('a');

                if (key == 38 ||
                    key == 40) {
                    if ($t.is(':focus')) {
                        e.preventDefault();

                        if (position.match(/^top$/i)) {
                            $list.find('li').last().find('a').focus();
                        } else {
                            $list.find('li').eq(0).find('a').focus();
                        }
                    } else if ($a.is(':focus')) {
                        e.preventDefault();

                        if (key == 38) {
                            $(':focus').parents('li').prev('li').find('a').focus();
                        } else {
                            $(':focus').parents('li').next('li').find('a').focus();
                        }
                    }
                } else if (key == 37 ||
                    key == 39) {
                    if ($a.is(':focus')) {
                        $(':focus').trigger('click');
                    }
                } else if (key == 27) {
                    if ($list.is(':visible')) {
                        e.preventDefault();

                        $listWrapper.addClass('hidden').removeAttr('style');
                        $list.html('');
                    }
                }
            });

            if (e.keyCode == 9 && !e.shiftKey) {
                var $focus = $(':focus'),
                    $li = $focus.parents('li').eq(0);

                if (
                    $li.is(':last-child') &&
                    $focus.parents('.' + classWrapper).length
                ) {
                    $focus.parents('.' + classListWrapper).addClass('hidden').removeAttr('style');
                }
            }
        }
    });
}

function labelSolr(item) {
    let label = '';
    let vowelRegex = '^[aieouAIEOU].*';
    item = item.data ? item.data : item;
    switch (item.solr_field) {
        case 'common_academie_value_ms' :
            label = 'Académie';
            break;
        case 'common_departement_value_ms' :
            label = 'Département';
            break;
            break;
        case 'common_region_value_ms' :
            label = 'Région';
            break;
        default:
            break;
    }

    return label + (item.name.match(vowelRegex) ? " d'" : ' de ');
}


$(function () {
    if ($('.search-ui-form-loc-input').length) {
        oniAutocomplete({
            input: $('.search-ui-form-loc-input input[type=text]'),
            url: '/onigeo/city_complete/<term>',
            method: 'get',
            dataType: 'json',
            trim: true,
            keyShow: 'name_postal',
            keySearch: 'name_postal',
            item: {
                addProperty: {
                    name: 'name_postal',
                    value: function (item) {
                        let tag = '';
                        if (item.solr_field) {
                            tag = labelSolr(item);
                        }
                        return tag + item.name + (!item.solr_field ? ' (' + new String(item.postal_code).padStart(5, '0') + ')' : '');
                    },
                },
            },
            minLength: 3,
            limit: 8,
            onItemSelect: function (item, $input, $list) {
                $input.attr('aria-expanded', 'false');
                $list.attr('aria-expanded', 'false').parents('.autocomplete-list-wrapper').addClass('hidden');
                $input.val('');
                let $form = $input.closest('.search-ui-form-loc-input');
                let $lat = $form.find('[name="search-ui-geo-latitude"]'),
                    $lng = $form.find('[name="search-ui-geo-longitude"]'),
                    $city = $form.find('[name="search-ui-geo-city"]'),
                    $dist = $form.find('.search-ui-geo-city-range-slider'),
                    $solrField = $form.find('[name="search-ui-geo-solr"]');
                if ($lat.length && $lng.length) {
                    let text = item.data.name;

                    if(item.data.solr_field) {
                        $solrField.val(item.data.solr_field).attr('value', item.data.solr_field).change();
                        text = labelSolr(item) + text;
                    } else {
                        if ($dist.attr('value')) {
                            text = text + ' - ' + $dist.attr('value') + ' km';
                        }
                        $solrField.removeAttr('value');
                    }
                    $lng.val(item.data.longitude).attr('value', item.data.longitude).click();
                    $city.val(text).attr('value', item.data.name).click();
                    $lat.val(item.data.latitude).attr('value', item.data.latitude).click();
                    $form.find('.search-ui-reset-geo').removeClass('hidden');
                }

            },
            onItemHover: function(item, $input, $list) {
                var tag = '';
                if (item.solr_field) {
                    tag = labelSolr(item);
                }
                $input.val(tag + item.data.name + (!item.data.solr_field ? ' (' + item.data.postal_code + ')' : ''));
            },
        });
    }
});
